







import Vue from 'vue';
export default Vue.extend({
  name: 'TextOrNA',
  props: {
    text: {
      type: String,
      default: '',
    },
  },
});
